import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography } from '@quillbot/design-system';
import { detectAgent } from 'core/utils';
import AffiliateButton from './AffiliateButton';

interface IProps {
  classes: Record<string, string>;
  /* classes: {
    font24: string;
    font35: string;
  }; */
}

function AffiliateQuality(props: IProps) {
  const { classes } = props;
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(!!detectAgent().isMobile);
  }, []);
  const qualities = [
    {
      emoji: 'emojis/beating.svg',
      text: 'You love us already!',
    },
    {
      emoji: 'emojis/trumpet.svg',
      text: 'You use QuillBot and can share your story with friends.',
    },
    {
      emoji: 'emojis/writing.svg',
      text: 'You have an audience of students, bloggers, writers, and professionals.',
    },
    {
      emoji: 'emojis/clap.svg',
      text: "You're passionate about helping your followers and fans succeed.",
    },
  ];

  const renderAffiliateQualities = () =>
    qualities.map((ele) => (
      <Box style={{ flexBasis: '100%' }} mt={{ xs: 1, sm: 1, md: 1 }} key={ele.text}>
        <Box
          className={props.classes.affiliateboxs}
          display="flex"
          flexDirection="column"
          px={1}
          flex={1}
          alignItems={isMobile ? 'center' : 'flex-start'}
        >
          <img src={ele.emoji} style={{ height: '34px', margin: 'auto' }} alt={ele.text} />
          <Box
            mt={isMobile ? 2 : 1}
            textAlign={isMobile ? 'center' : 'center'}
            style={{ width: '100%' }}
          >
            <Typography variant="body1">{ele.text}</Typography>
          </Box>
        </Box>
      </Box>
    ));
  return (
    <Box mt={8}>
      <Grid container className={props.classes.affiliateQualityWrapper} justifyContent="center">
        <div className="container">
          <Grid item sm={12} style={{ textAlign: 'center' }}>
            <Typography variant="h4" className={props.classes.font35}>
              Affiliate Qualities
            </Typography>
          </Grid>

          <Box
            display="flex"
            style={{ margin: '16px 0px 40px', display: 'flex' }}
            flexDirection={isMobile ? 'column' : 'row'}
          >
            {renderAffiliateQualities()}
          </Box>

          <AffiliateButton classes={classes} />
        </div>
      </Grid>
    </Box>
  );
}

export default AffiliateQuality;
